module.exports = __webpack_public_path__ + "static/media/demo-5.8442b143.jpg";